<template>
  <ul class="" v-if="access==='admin' && $store.getters['User/isAdmin'] || access===''">
    <li class="dashboard" v-b-toggle="`collapse-${id}`" @click="customAction">
      <router-link :to="route">

        <b-icon :icon="icon"></b-icon>
        {{ name }}
        <b-icon v-if="children.length>0" icon="arrow-down-circle" class="d-inline"></b-icon>
      </router-link>

    </li>

    <SubItem v-if="children.length"
             :id="id"
             :step="1"
             :children="children"
    />

  </ul>
</template>

<script>
import SubItem from './subItem'

export default {
  name: "item",
  components: {SubItem},
  props: ['name', 'icon', 'route', 'children', 'id', 'action', 'access'],
  methods: {
    customAction() {
      console.log('item')
      if (this.action !== undefined) {
        this.action()
      }
    }
  }
}
</script>

<style scoped>
.dashboard {
  padding-top: 2rem;
  padding-right: 1rem;
  text-align: right;
  text-decoration: none;
  cursor: pointer;
}


ul li {
  list-style: none;
}


ul li a:focus {

  color: #7f9afd;

}

ul li a {
  color: #7f807d;
  text-decoration: none;
  display: block;
  padding: 15px 0 15px 10px;
  font-size: 15px;
  outline: none;
}

</style>